import React from 'react';
import { Link } from "react-router-dom";


import UploadExportingFromSis from './upload_instructions/upload_exporting_from_sis';
import UploadImportingIntoEdario from './upload_instructions/upload_importing_into_edario';

export default function UploadDataDocs({ topic, setTopic, sis, setSis, schoolType }) {
	const sis_list = [
		{sis:'genesis', name: 'Genesis', phone:'732.521.2002 x4', email:null, interface:true, pdf_instructions: {'courses': true, 'teachers':false, 'previous_sections':true, 'students':true, 'student_requests':true}}, 
		{sis:'realtime', name: 'Realtime', phone:'732.678.5142', email:' support@realitinc.com', interface:false, pdf_instructions: {'courses': false, 'teachers':false, 'previous_sections':false, 'students':false, 'student_requests':false}}, 
		{sis:'powerschool', name: 'Powerschool', phone:'866.434.6276', email:null, interface:false, pdf_instructions: {'courses': false, 'teachers':false, 'previous_sections':false, 'students':false, 'student_requests':false}}, 
		{sis:'gradelink', name: 'Gradelink', phone:'800.742.3083', email:null, interface:false, pdf_instructions: {'courses': false, 'teachers':false, 'previous_sections':false, 'students':false, 'student_requests':false}}, 
		{sis:'skyward', name: 'Skyward', phone:'800.236.0001', email:null, interface:false, pdf_instructions: {'courses': false, 'teachers':false, 'previous_sections':false, 'students':false, 'student_requests':false}}, 
		{sis:'infinite_campus', name: 'Infinite Campus', phone:null, email:null, interface:false, pdf_instructions: {'courses': false, 'teachers':false, 'previous_sections':false, 'students':false, 'student_requests':false}}
	];
	
	const changeSIS = (new_sis) => {
		setSis(new_sis);
		setTopic(null);
	}

	const sis_index = sis_list.findIndex(sis_info => sis_info.sis === sis);
	const sis_info = (sis_index !== -1) ? sis_list[sis_index] : null;
	const sis_name = sis_info ? sis_info.name : null;
	
	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Upload Data</div>
			<p className='documentation-question-heading'>What system do you currently use?</p>
			<div className='choose-topic' style={{gridTemplateColumns:'auto auto', width:'min-content'}}>
				{sis_list.map((sis_option, i) => (
					<Link className={`sis-type-btn ${sis_option.sis === sis ? 'sis-type-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_wizard/upload_data/null/${sis_option.sis}`} onClick={() => changeSIS(sis_option.sis)} key={i}>{sis_option.name}</Link>	
				))}
			</div>
			{sis &&
				<>
				<p className='documentation-question-heading'>What do you need help with?</p>
				<div className='choose-topic'>
					<Link className={`choose-topic-btn ${topic === 'exporting_from_sis' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_wizard/upload_data/exporting_from_sis/${sis}`} onClick={() => setTopic('exporting_from_sis')}>Exporting data out of {sis_name}</Link>
					<Link className={`choose-topic-btn ${topic === 'importing_into_edario' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_wizard/upload_data/importing_into_edario/${sis}`} onClick={() => setTopic('importing_into_edario')}>Importing data into Edario</Link>	
				</div>
				</>
			}
			{(topic === 'exporting_from_sis') ?
			(
				<UploadExportingFromSis sisList={sis_list} sis={sis} />
			):(topic === 'importing_into_edario') ?
			(
				<UploadImportingIntoEdario sisList={sis_list} sis={sis} schoolType={schoolType} topic={topic} setTopic={setTopic}/>
			):(null)
			}
		</div>
	);
}
